import React, { memo } from 'react'
import Icon from 'react-native-vector-icons/MaterialIcons'
import { isEqual } from 'lodash'

import { CellProps } from './TableTypes'

const BooleanCell = ({ cell }: CellProps): JSX.Element => {
  return (
    <Icon
      name={cell.value ? 'check-box' : 'check-box-outline-blank'}
      size={24}
      color={cell.value ? '#00a898' : '#bbbbbb'}
    />
  )
}

export default memo(BooleanCell, isEqual)
